/**
 * Check if string is stringified.
 *
 * @param  {any} str String to test
 * @return {boolean}
 */
export function isStringified(str: any): boolean {
  try {
    JSON.parse(str);
  } catch {
    return false;
  }

  return true;
}
